// @ts-ignore
import classes from './close-button.css'
import { dataHook } from '../../utils'

const icon =
  '<svg viewBox="0 0 23 23" fill="currentColor" width="23" height="23"><path d="M10.9393398,12 L6,7.06066017 C5.70710678,6.76776695 5.70710678,6.29289322 6,6 C6.29289322,5.70710678 6.76776695,5.70710678 7.06066017,6 L12,10.9393398 L16.9393398,6 C17.232233,5.70710678 17.7071068,5.70710678 18,6 C18.2928932,6.29289322 18.2928932,6.76776695 18,7.06066017 L13.0606602,12 L18,16.9393398 C18.2928932,17.232233 18.2928932,17.7071068 18,18 C17.7071068,18.2928932 17.232233,18.2928932 16.9393398,18 L12,13.0606602 L7.06066017,18 C6.76776695,18.2928932 6.29289322,18.2928932 6,18 C5.70710678,17.7071068 5.70710678,17.232233 6,16.9393398 L10.9393398,12 Z"></path></svg>'
export const closeButtonTemplate = (hook: string, modifier: string) =>
  `<button class="${classes.button} ${modifier}" ${dataHook(
    hook,
  )} aria-label="close">${icon}</button>`
